(() => {
  const config = JSON.parse(document.getElementById('delavie-preorder-config').textContent);
  const protectedIds = new Set(config.variants.filter(variant => variant.needsPlan).map(variant => String(variant.id)));
  const needsPlan = item => protectedIds.has(String(item.id)) && !item.selling_plan;

  const withTimeout = promise => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(config.error)), 8000);
    Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timer));
  });

  async function resolvePlan(id) {
    // Use Dibs' eligibility lookup so expired or unavailable plans cannot be added.
    await withTimeout(new Promise(resolve => {
      const check = () => {
        if (typeof window.lbOrdereasyGetProducts === 'function') return resolve();
        if (Date.now() - started < 7900) setTimeout(check, 100);
      };
      const started = Date.now();
      check();
    }));
    const products = await withTimeout(window.lbOrdereasyGetProducts({ productHandles: [config.handle] }));
    const product = products?.find(product => product.handle === config.handle);
    const variant = product?.variants?.find(variant => variant.id.split('/').pop() === String(id));
    const plans = variant?.applicableSellingPlans || [];
    if (plans.length !== 1 || plans[0].paymentModeType !== 'full') throw new Error(config.error);
    return plans[0].id.split('/').pop();
  }

  async function prepareBody(body, headers = {}) {
    const isJSON = new Headers(headers).get('Content-Type')?.includes('application/json');
    if (isJSON) {
      const data = JSON.parse(body);
      const items = data.items || [data];
      for (const item of items) {
        if (needsPlan(item)) item.selling_plan = await resolvePlan(item.id);
      }
      return JSON.stringify(data);
    }
    const data = body instanceof FormData ? new FormData() : new URLSearchParams(body);
    if (body instanceof FormData) body.forEach((value, key) => data.append(key, value));
    if (needsPlan({ id: data.get('id'), selling_plan: data.get('selling_plan') })) {
      data.set('selling_plan', await resolvePlan(data.get('id')));
    }
    return body instanceof FormData ? data : data.toString();
  }

  function showError() {
    document.querySelector('[data-preorder-cart-error]')?.remove();
    const message = document.createElement('div');
    message.setAttribute('data-preorder-cart-error', '');
    message.setAttribute('role', 'alert');
    message.className = 'alert alert--error';
    message.append(document.createTextNode(`${config.error} `));
    const link = document.createElement('a');
    link.href = config.url;
    link.textContent = config.linkLabel;
    message.append(link);
    const target = document.activeElement?.closest('product-form, .product-item, .upsell-text-container');
    (target || document.querySelector('#site-cart-sidebar.opened') || document.querySelector('main')).append(message);
    message.scrollIntoView({ block: 'nearest' });
  }

  window.delavieAddToCart = async (url, options) => {
    let body;
    try {
      body = await prepareBody(options.body, options.headers);
    } catch (error) {
      showError();
      throw error;
    }
    return fetch(url, { ...options, body });
  };

  const nativeSubmissions = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action).pathname.endsWith('/cart/add')) return;
    const data = new FormData(form);
    if (!needsPlan({ id: data.get('id'), selling_plan: data.get('selling_plan') })) return;
    const component = form.closest('product-form');
    if (component && (!document.body.classList.contains('template-cart') || component.hasAttribute('data-force-form'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (nativeSubmissions.has(form)) return;
    nativeSubmissions.add(form);
    try {
      const body = await prepareBody(data);
      let input = form.querySelector('[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.append(input);
      }
      input.value = body.get('selling_plan');
      form.requestSubmit(event.submitter || undefined);
    } catch (error) {
      showError();
    } finally {
      nativeSubmissions.delete(form);
    }
  }, true);

  function labelButtons() {
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"], button[data-variant-id], button[data-variant]').forEach(button => {
      const id = button.dataset.variantId || button.dataset.variant || button.closest('form')?.querySelector('[name="id"]')?.value;
      if (!protectedIds.has(String(id)) || button.disabled) return;
      const label = button.querySelector('.button__text') || button;
      for (const node of label.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && /add\s+to\s+cart/i.test(node.textContent)) {
          node.textContent = node.textContent.replace(/add\s+to\s+cart/i, config.label);
        }
      }
    });
  }
  labelButtons();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; labelButtons(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
